module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('detail-view', {
    attrs: {
      "endpoint": _vm.endpoint + 'organizations',
      "name": "Organization",
      "parentRoute": "organizations",
      "permissions": "organizations",
      "values": _vm.values
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e344089","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationEdit.vue
// module id = 421
// module chunks = 1